import React from "react"
import styled from "styled-components"
import cashfreeLogo from "resources/logo/cashfree.png"
import cricvizLogo from "resources/logo/cricviz.png"
import d11Logo from "resources/logo/d11.png"
import { Box, Grid, Typography } from "@material-ui/core"
import { bps } from "theme"

const StyledContainer = styled.div`
  background-color: #fafcfd;
  color: #303e4f;
`
const StyledDiv = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 64px 16px;
  text-align: center;
  text-transform: uppercase;

  .d11-logo {
    height: 45px;
  }

  ${bps.down("sm")} {
    .sponsor {
      display: flex;
      flex-direction: column;
    }
  }
`

export default () => {
  return (
    <StyledContainer>
      <StyledDiv>
        <Typography variant="h2">Sixer is proudly powered by</Typography>
        <Box my={4} />
        <Grid
          className="sponsor"
          container
          justify="center"
          alignItems="center"
          spacing={4}
        >
          <Grid item>
            <a href="https://www.dream11.com/" target="_blank">
              <img
                className="d11-logo"
                src={d11Logo}
                loading="lazy"
                alt="dream11-logo"
              />
            </a>
          </Grid>

          <Box mx={4} />

          <Grid item>
            <a href="https://www.cricviz.com/" target="_blank">
              <img src={cricvizLogo} loading="lazy" alt="cricviz logo" />
            </a>
          </Grid>

          <Box mx={4} />

          <Grid item>
            <a href="https://www.cashfree.com/" target="_blank">
              <img src={cashfreeLogo} loading="lazy" alt="cashfree logo" />
            </a>
          </Grid>
        </Grid>
      </StyledDiv>
    </StyledContainer>
  )
}
